import { AccountType, CaseType } from 'src/graphql';
import { User } from 'src/types';

export const caseAttributesHelpers = (
  caseById: CaseType,
  currentUser: User | null,
) => {
  const caseLead = caseById?.CaseLead;

  const isSuperAdmin =
    currentUser &&
    currentUser.Accounts?.some((account) =>
      (account as unknown as AccountType).Roles?.some(
        (role) =>
          role.SystemPermissions?.some(
            // eslint-disable-next-line max-nested-callbacks
            (permission) => permission.permission === 'EDIT_ALL_CASES',
          ) &&
          role.SystemPermissions?.some(
            // eslint-disable-next-line max-nested-callbacks
            (permission) => permission.permission === 'LIST_ALL_CASES',
          ),
      ),
    );

  const isCaseLead =
    currentUser && caseLead && String(currentUser.id) === String(caseLead.id);

  const report = caseById.Reports![0];

  const isManualIntakeReport = report.source === 'manual-case-creation';

  const submittedAt = report.submittedAt;
  const companyCreatedAt = caseById.CaseAttributes?.companyCreatedAt;
  const readAt = caseById.CaseAttributes?.readAt;
  const investigatingAt = caseById.CaseAttributes?.investigatingAt;
  const closedAt = caseById.CaseAttributes?.closedAt;

  return {
    isSuperAdmin,
    isCaseLead,
    isManualIntakeReport,
    submittedAt,
    companyCreatedAt,
    readAt,
    investigatingAt,
    closedAt,
  };
};
